/*
 * File: UIRadioGroup.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays a related group of radio button input elements
 */
import React from "react";
import UIRadioListItem from "../UIRadioListItem";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

const UIRadioGroup = ({ field, parentOnChange, value }) => {
  const handleChange = event => {
    const selectedId = event.target.id;
    if (typeof parentOnChange === "function") {
      parentOnChange(field.name, selectedId);
    } else if (typeof field.update === "function") {
      field.update(selectedId);
    }
  };

  return field.options.map((option, idx) => (
    <UIRadioListItem
      parentOnChange={handleChange}
      name={option.name}
      optionId={option.id}
      selectedId={value}
      key={idx}
    />
  ));
};

UIRadioGroup.propTypes = {
  field: PropTypes.object.isRequired,
  parentOnChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default observer(UIRadioGroup);
